module.exports = __webpack_public_path__ + "d9ae71104ee140546abc1d82bfc2ddf2.pdf";